/**
 * Formats a byte count as a human-readable string with KB or MB suffix.
 * Rounded using binary units (1 KB = 1024 bytes). Returns '—' for nullish input.
 * @param bytes - number of bytes (non-negative integer) or nullish
 * @returns formatted string, e.g. "0 KB", "512 KB", "3.4 MB"
 */
export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined) {
    return '—';
  }
  const KB = 1024;
  const MB = KB * 1024;
  if (bytes >= MB) {
    return `${(bytes / MB).toLocaleString(undefined, { maximumFractionDigits: 1 })} MB`;
  }
  return `${Math.round(bytes / KB).toLocaleString()} KB`;
}
